import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Роутер не прокручивает страницу сам: новая страница открывалась с того места, где человек
// остановился на прежней (после удаления список компаний открывался прокрученным вниз).
// Стоит один раз внутри роутера и возвращает страницу наверх при каждом переходе.
function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}

export default ScrollToTop;
